// extracted by mini-css-extract-plugin
export default {"blockLoading":"BlockLoading_blockLoading__RNU2u","loader":"BlockLoading_loader__xcqcF","rot1":"BlockLoading_rot1__ZN9Ob"};